import Left from "./Left";
import Rigth from "./Rigth";

export const RetangleBlue = {
    Left: Left,
    Rigth: Rigth,
};
